import { relations } from 'drizzle-orm'
import { integer, jsonb, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

export const newsletterStatusEnum = pgEnum('newsletter_status', [
  'draft',
  'sending',
  'sent',
])

export const newsletters = pgTable(
  'newsletters',
  {
    ...getBaseFields(),
    subject: text().notNull(),
    // Staff-only label to tell near-identical newsletters apart in the list
    // (e.g. same subject, different audience). Never shown to recipients.
    internalName: text(),
    designJson: jsonb(),
    html: text(),
    status: newsletterStatusEnum().notNull().default('draft'),
    audienceFilter: jsonb(),
    recipientCount: integer(),
    sentAt: getTimestampWithTimezone(),
    sentByUserId: getNullableIdReference(() => users.id),
  },
  (table) => getBaseIndexes('newsletters', table),
)

export const newslettersRelations = relations(newsletters, ({ one }) => ({
  sentByUser: one(users, {
    fields: [newsletters.sentByUserId],
    references: [users.id],
  }),
}))
